
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqRGH6Du_45zzbOGebPxnOlLqhxIQcUUEHzwG2_45AzJhZc9wMeta } from "/codebuild/output/src853587053/src/src/pages/faq.vue?macro=true";
import { default as menuoI2FG7SuafqFgTIKBYbmVgrI_pzZve_SYKJ5GF9ti4QMeta } from "/codebuild/output/src853587053/src/src/pages/menu.vue?macro=true";
import { default as indexm3JTul3_45r8OSMFCE21MNVuU9_berdgVLhZcgA1mi9BYMeta } from "/codebuild/output/src853587053/src/src/pages/index.vue?macro=true";
import { default as contactHtqgSidJH1aHuCFcM4j2_xGQ3sSfno4Lj_TPXeQzU_45cMeta } from "/codebuild/output/src853587053/src/src/pages/contact.vue?macro=true";
import { default as tutorialCOaTKoHXwjeEnm40NqND1zNALfKG8hZ0luz9w7UjNeUMeta } from "/codebuild/output/src853587053/src/src/pages/tutorial.vue?macro=true";
import { default as agreementwaPOABHaYh_45Pdgacfb9l013i27FW_RVGtNspyc2WqDwMeta } from "/codebuild/output/src853587053/src/src/pages/agreement.vue?macro=true";
import { default as about_45pass5qE1fd9hMXfNc3mmtoES2OkCDhnO2_45K64nxqRQdRXXoMeta } from "/codebuild/output/src853587053/src/src/pages/about-pass.vue?macro=true";
import { default as indexIetNj_a9ZL7GRquQsosobrHMYaX9Urly6_uerGyvPBkMeta } from "/codebuild/output/src853587053/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93Me3SdNTWeHH_zAtQUkjTawIdx5eIfuInbgXRPDuTcrYMeta } from "/codebuild/output/src853587053/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceWnr0gH9JHVXZMmUIQdtDIqSx5zsq0tUEtYq_45jBpBNeEMeta } from "/codebuild/output/src853587053/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93Wu0iaVxs773mF5auJxo5OKOddTcXzkvH_7y_ZJvx4kUMeta } from "/codebuild/output/src853587053/src/src/pages/notice/[id].vue?macro=true";
import { default as indexPpEqGY2tbpZJeDbYDQPgfAKfm57AyIJRl3_2eKcv_HAMeta } from "/codebuild/output/src853587053/src/src/pages/coupon/index.vue?macro=true";
import { default as indexWD_Ge9lmBngNiTmvWpej2Diwp2czOU6vUiEK2vkvb_QMeta } from "/codebuild/output/src853587053/src/src/pages/mypage/index.vue?macro=true";
import { default as index4p8ZVorCLjjC6D54XSynf_4520RZn0V_45S1N54wUWtBZkoMeta } from "/codebuild/output/src853587053/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93OiTFW2bVspuVXDXlrdawfblwkGTC_bgsc7_452lHGI2gcMeta } from "/codebuild/output/src853587053/src/src/pages/parking/[id].vue?macro=true";
import { default as indexEHFNiciBMHC3u9T3tdh7uSq5yPkUtq9PcellpmZfRXMMeta } from "/codebuild/output/src853587053/src/src/pages/history/index.vue?macro=true";
import { default as index_45NOxA2QVOMtJdMIBJGaE42adyOkYbBfsKpfcugPp2PMMeta } from "/codebuild/output/src853587053/src/src/pages/monthly/index.vue?macro=true";
import { default as indexYw9dtde5uHUlNgHbPquhBQstSFN9B4CfhtHFvAe4n2wMeta } from "/codebuild/output/src853587053/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexm8jiuTMITaAi_450s2M3JGFYG7wiRWX1asy3EnS0RBWtcMeta } from "/codebuild/output/src853587053/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavi3Uq_lgYQU_45u_LVdJoWjPcCiIN1zD_60NJqIT4_pQ3fwMeta } from "/codebuild/output/src853587053/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit98ae2NNEjY852ZLYj81RE6ZRQwJa_zVMjkV3cyZ3RocMeta } from "/codebuild/output/src853587053/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreement1NWS4Rylbk6R3z43Hg8PRjy_45Bgp9SY8cfjThYqP817QMeta } from "/codebuild/output/src853587053/src/src/pages/pass-agreement.vue?macro=true";
import { default as index6AYnPqBCafgeFquw5u49Y2v5b97zKtAh_6_45Hu7kOdHUMeta } from "/codebuild/output/src853587053/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dV4_I_45W2yEBdVSkLlPj2wQvhbcuk0496t46aTaEMixUwMeta } from "/codebuild/output/src853587053/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirm8ck21IzG41WtL2lWp7Y_O8cpKewDEhleMZLUezvHbj0Meta } from "/codebuild/output/src853587053/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexUo8qWmA6ynFuZz9lI5ftPKmj8UpqGssGgVQSgf6NX28Meta } from "/codebuild/output/src853587053/src/src/pages/card/create/index.vue?macro=true";
import { default as indexw19qNimj0yl1jiYSBZUOUvhbmFDn4lY_CTAuloO69VkMeta } from "/codebuild/output/src853587053/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmGOgLhFUT1_45E0KmBLA1RYUKjG3lcuIozHUBF2tbyWHZkMeta } from "/codebuild/output/src853587053/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmgJ50L2ey5GbFbkPE6ZnYiQIuBaRhci_45Tt1VYI2UL9XEMeta } from "/codebuild/output/src853587053/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeQjR_yZU40vgPPtR65er5jbY966jKzxPoesdzQ8A_45_450MMeta } from "/codebuild/output/src853587053/src/src/pages/membership/complete.vue?macro=true";
import { default as registerKT_45J7Ew1kcPzkBmT_oSggGyKJ5O_45ufheY4kraP6qzToMeta } from "/codebuild/output/src853587053/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_930p_YeUtWD5nmyGBOCdDm_2_6fo6nLXpQPFSzOHE9NOMMeta } from "/codebuild/output/src853587053/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirm0RFX3RB_45snMAZsbYTLm8glKfa6Qgqv7wEsxROGt29WQMeta } from "/codebuild/output/src853587053/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93v1nfjTUqw8rZk6ABYdR6PwUvDiN61hQyE6hwTdovEKIMeta } from "/codebuild/output/src853587053/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexb1onvl5ZAUQGzJD1b_45uWgRUfhFyZWQHPtUpc8x3uHhMMeta } from "/codebuild/output/src853587053/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeU23CJhXZSAc_2cEuI1oncxQobazX6Qpl1WCwM_G1vw0Meta } from "/codebuild/output/src853587053/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codelZQn0WZ7dbFbWzkA0Ooz4Bj2QqOV4_tJqdvYXK_45CFVUMeta } from "/codebuild/output/src853587053/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completetqe7vqELmCt_45ckzZrMbOumMAW8lq2V2VRAJJrN9SvPMMeta } from "/codebuild/output/src853587053/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerlb_45ojCENQJ_45nDr6NC6tgjdZGsVKYuMmr2dhqQO5e07QMeta } from "/codebuild/output/src853587053/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeOo1_45xLMTSZ13_458CghbTdDSqmfOeXWjq_45D_lFcno8fF8Meta } from "/codebuild/output/src853587053/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexLba3Ds9A_45jpGiAmtqAu1jKKqk4ql0tR_Q_45wm2ccR_eAMeta } from "/codebuild/output/src853587053/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmss8FeIfwLuf8jV69Pf6zabK2pEGM0Zvi3qvuf5RWPIIMeta } from "/codebuild/output/src853587053/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeKF_45_1Ci3a3GILx4Jm95bOXlRUqKueGJvg6AHholNLhEMeta } from "/codebuild/output/src853587053/src/src/pages/reset-password/complete.vue?macro=true";
import { default as index0SO5uwjPJCaM7PWSPsAWCspaZMC8FTWweP4BQ1KysLwMeta } from "/codebuild/output/src853587053/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93uuP0Czp78mo5Ixx4KwJH9_lZinwcawH22_UGK49lCxIMeta } from "/codebuild/output/src853587053/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeJ0V_OcmUZ813gFr8tEiqjs9HoF7VbE8PnM_A9l7mRTIMeta } from "/codebuild/output/src853587053/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasaNaTk90oTlM2u706xv02XUV1g3FJoprtETDry8NlgaQMeta } from "/codebuild/output/src853587053/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleR8hStCEFVEKbbaE4fhYefIbNE_akYfECOcYn7nSNGmkMeta } from "/codebuild/output/src853587053/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45email07C_4Sr0kAQsUJf827QO2b0FUSbPd5dbr2EKjfO6Yz4Meta } from "/codebuild/output/src853587053/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmq91sZyRQZc26_45yvL4ofe_45rXJu_455O9XEzOcSmEVHrl7YMeta } from "/codebuild/output/src853587053/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consent5dJU1ttZNpYvjllTgEJPieqnPb96uNpuz8Ep3DkzL2cMeta } from "/codebuild/output/src853587053/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirm1b6JI9hadp7gIT4QVlZJ1w1cvJsny_45ITU2DzUdgW06MMeta } from "/codebuild/output/src853587053/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate4xPB8pboNxNjwLswuwV6mgDFp63tZqHX5P0xKsav5WAMeta } from "/codebuild/output/src853587053/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeWA_FSH9CWIx9dJm7qhBp1hRZo3J9lOlbMhfsex2DE_AMeta } from "/codebuild/output/src853587053/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeJcuZEK2D_7pGS90c9y27CJd6Wejlz82SsaWE11thso8Meta } from "/codebuild/output/src853587053/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45password2VMDsBDri6DL93CBqMHAsuvjqARBMD8aQ_R0WWoeBfkMeta } from "/codebuild/output/src853587053/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasZkeZgX6Ge8_lm5eB1bZ1MlTRO_45oojKBLesKI7UChvY4Meta } from "/codebuild/output/src853587053/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerOEakCe6PMI3CRlYEQLWMz7xS7cPAoiyqbNVvAIOSgBAMeta } from "/codebuild/output/src853587053/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeqQLPfbKQPS_45cURK5XYV_T9RsjB9kziiQPrlUghEYdYMMeta } from "/codebuild/output/src853587053/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexN4GEyXVtQCEHQPSXQzyHB0813KiHfaNC2EdmZbiidfcMeta } from "/codebuild/output/src853587053/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexEZqWPqwZ9sDFpnVbXSg_1ZaTyIfnxZEjTpAu4ReXtQ0Meta } from "/codebuild/output/src853587053/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexSyFHoNsBtqqI36mQUXieF029euemjmZrtokZWm4z5t8Meta } from "/codebuild/output/src853587053/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexsS52qQsUFIIul9XVq9r_ujb_ffs9ZUZ2eu_45a1PrVvP0Meta } from "/codebuild/output/src853587053/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatelI_45IFw6a61eL0jmLDf2SXgsXblxnacAWd2iEaU9Ce7UMeta } from "/codebuild/output/src853587053/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete50dL7PNlqgqvkeemKb9femqWdEl8Lj7tkqRu8_45vXwigMeta } from "/codebuild/output/src853587053/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmZ_45gGZBxS6u_4583PtSEf8oAVT7uA1IL9ZpAAHm3aB0avMMeta } from "/codebuild/output/src853587053/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexTbOVZARJW1AZfCejM4c1Kxrz8NR1K5j1aksweMGUiXMMeta } from "/codebuild/output/src853587053/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete05TjpVk6TsOIVMFWeh02yyuXZRQ9OCOWwKoyrqKljSEMeta } from "/codebuild/output/src853587053/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateqZO9SYSyrUf9TS1CBXCDQyl7xSu8PniLZ3oS3Yl_45WcYMeta } from "/codebuild/output/src853587053/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexBFbitrMioMtLpwYDmS823Ns_BERkoKFRz8YYtQ773EUMeta } from "/codebuild/output/src853587053/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexvQstz_MOVc2tUplVdvnOm7XquEdpR8ot7_AArxh3TMYMeta } from "/codebuild/output/src853587053/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeDP1AMDGVY7YeovRSsfkKav2xD2phNo19odSOIDEj1u8Meta } from "/codebuild/output/src853587053/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexpysxsykrLf53haRk7op_45P_m07CsGcVBBXcgMErOY2VgMeta } from "/codebuild/output/src853587053/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeLioc_454kvZPrxyFz8yGiTN61pXVDYUu3nZ_45KMd1sF2WcMeta } from "/codebuild/output/src853587053/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexFI8iYWxRObC6qarv_45yR_45buPRBApGmn9PPaKcab0KYnQMeta } from "/codebuild/output/src853587053/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexpSX89gtqXZPeqlrSvFurDDb8Rymvh1xEhRdYMYEIiP0Meta } from "/codebuild/output/src853587053/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexCGcKpDhT18ijmxdjEOXbnPK8tnkDwPymkyaqRP4724YMeta } from "/codebuild/output/src853587053/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatejInaoyOXdXZvNqPKeY94lwkr9mx0TNPiaWGu9Pco1AoMeta } from "/codebuild/output/src853587053/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmSK_akaDyM6FZ9JDGSY4EEOxHkzT1rd7ppgtZlu_5heIMeta } from "/codebuild/output/src853587053/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src853587053/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuoI2FG7SuafqFgTIKBYbmVgrI_pzZve_SYKJ5GF9ti4QMeta || {},
    component: () => import("/codebuild/output/src853587053/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexm3JTul3_45r8OSMFCE21MNVuU9_berdgVLhZcgA1mi9BYMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src853587053/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src853587053/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src853587053/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src853587053/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src853587053/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src853587053/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src853587053/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src853587053/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src853587053/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexPpEqGY2tbpZJeDbYDQPgfAKfm57AyIJRl3_2eKcv_HAMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src853587053/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src853587053/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src853587053/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src853587053/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexEHFNiciBMHC3u9T3tdh7uSq5yPkUtq9PcellpmZfRXMMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src853587053/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src853587053/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexYw9dtde5uHUlNgHbPquhBQstSFN9B4CfhtHFvAe4n2wMeta || {},
    component: () => import("/codebuild/output/src853587053/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexm8jiuTMITaAi_450s2M3JGFYG7wiRWX1asy3EnS0RBWtcMeta || {},
    component: () => import("/codebuild/output/src853587053/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src853587053/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src853587053/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src853587053/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src853587053/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src853587053/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src853587053/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexUo8qWmA6ynFuZz9lI5ftPKmj8UpqGssGgVQSgf6NX28Meta || {},
    component: () => import("/codebuild/output/src853587053/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src853587053/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmGOgLhFUT1_45E0KmBLA1RYUKjG3lcuIozHUBF2tbyWHZkMeta || {},
    component: () => import("/codebuild/output/src853587053/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmgJ50L2ey5GbFbkPE6ZnYiQIuBaRhci_45Tt1VYI2UL9XEMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src853587053/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeQjR_yZU40vgPPtR65er5jbY966jKzxPoesdzQ8A_45_450MMeta || {},
    component: () => import("/codebuild/output/src853587053/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerKT_45J7Ew1kcPzkBmT_oSggGyKJ5O_45ufheY4kraP6qzToMeta || {},
    component: () => import("/codebuild/output/src853587053/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src853587053/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirm0RFX3RB_45snMAZsbYTLm8glKfa6Qgqv7wEsxROGt29WQMeta || {},
    component: () => import("/codebuild/output/src853587053/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src853587053/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src853587053/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeU23CJhXZSAc_2cEuI1oncxQobazX6Qpl1WCwM_G1vw0Meta || {},
    component: () => import("/codebuild/output/src853587053/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codelZQn0WZ7dbFbWzkA0Ooz4Bj2QqOV4_tJqdvYXK_45CFVUMeta || {},
    component: () => import("/codebuild/output/src853587053/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completetqe7vqELmCt_45ckzZrMbOumMAW8lq2V2VRAJJrN9SvPMMeta || {},
    component: () => import("/codebuild/output/src853587053/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerlb_45ojCENQJ_45nDr6NC6tgjdZGsVKYuMmr2dhqQO5e07QMeta || {},
    component: () => import("/codebuild/output/src853587053/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src853587053/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src853587053/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmss8FeIfwLuf8jV69Pf6zabK2pEGM0Zvi3qvuf5RWPIIMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src853587053/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeKF_45_1Ci3a3GILx4Jm95bOXlRUqKueGJvg6AHholNLhEMeta || {},
    component: () => import("/codebuild/output/src853587053/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(index0SO5uwjPJCaM7PWSPsAWCspaZMC8FTWweP4BQ1KysLwMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src853587053/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src853587053/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeJ0V_OcmUZ813gFr8tEiqjs9HoF7VbE8PnM_A9l7mRTIMeta || {},
    component: () => import("/codebuild/output/src853587053/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src853587053/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleR8hStCEFVEKbbaE4fhYefIbNE_akYfECOcYn7nSNGmkMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src853587053/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45email07C_4Sr0kAQsUJf827QO2b0FUSbPd5dbr2EKjfO6Yz4Meta || {},
    component: () => import("/codebuild/output/src853587053/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmq91sZyRQZc26_45yvL4ofe_45rXJu_455O9XEzOcSmEVHrl7YMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src853587053/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consent5dJU1ttZNpYvjllTgEJPieqnPb96uNpuz8Ep3DkzL2cMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src853587053/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirm1b6JI9hadp7gIT4QVlZJ1w1cvJsny_45ITU2DzUdgW06MMeta || {},
    component: () => import("/codebuild/output/src853587053/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src853587053/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeWA_FSH9CWIx9dJm7qhBp1hRZo3J9lOlbMhfsex2DE_AMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src853587053/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeJcuZEK2D_7pGS90c9y27CJd6Wejlz82SsaWE11thso8Meta || {},
    component: () => import("/codebuild/output/src853587053/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45password2VMDsBDri6DL93CBqMHAsuvjqARBMD8aQ_R0WWoeBfkMeta || {},
    component: () => import("/codebuild/output/src853587053/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src853587053/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerOEakCe6PMI3CRlYEQLWMz7xS7cPAoiyqbNVvAIOSgBAMeta || {},
    component: () => import("/codebuild/output/src853587053/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeqQLPfbKQPS_45cURK5XYV_T9RsjB9kziiQPrlUghEYdYMMeta || {},
    component: () => import("/codebuild/output/src853587053/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src853587053/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src853587053/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src853587053/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src853587053/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src853587053/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src853587053/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src853587053/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src853587053/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src853587053/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src853587053/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src853587053/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src853587053/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src853587053/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src853587053/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src853587053/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src853587053/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src853587053/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src853587053/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src853587053/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src853587053/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]